import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
  // TEMP FIX
  setInterval(() => {
    for (const key in localStorage) {
      if (key.startsWith("api")) {
        localStorage.removeItem(key);
      }
    }
  }, 15 * 1000);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

declare global {
  interface Window {
    emitFilterTimeout: any;
    filterResult: number[];
  }
  interface Date {
    toMyISOString(): string;
  }
}

Date.prototype.toMyISOString = function (): string {
  return new Date(
    this.getTime() - this.getTimezoneOffset() * 1000 * 60,
  ).toISOString();
};
